<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">ページテンプレート新規作成</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area">
        <div class="column-list" (dragstart)="onDragstartBody($event)">
          <div class="list-input-title">ページテンプレート名</div>
          <div class="list-input-content">
            <input class="text-label-required" type="text" id="txti_PageTemplateName" style="width:27rem;"
              plessInputTextSub [restrict]="'[ -￮]'" [(ngModel)]="pageTemplateName" [maxlength]="25" [tabindex]="0">
          </div>

          <div class="list-input-title">ページ領域始点X(mm)</div>
          <div class="list-input-content">
            <input class="align-right" type="text" id="txti_PageAreaX" readonly style="width:8rem;"
              plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="8" [(ngModel)]="pageAreaX" [tabindex]="0">
          </div>

          <div class="list-input-title">ページ領域始点Y(mm)</div>
          <div class="list-input-content">
            <input class="align-right" type="text" id="txti_PageAreaY" readonly style="width:8rem;"
              plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="8" [(ngModel)]="pageAreaY" [tabindex]="0">
          </div>

          <div class="list-input-title">ページ領域幅(mm)</div>
          <div class="list-input-content">
            <input class="text-label-required align-right" type="text" id="txti_PageAreaWidth" style="width:8rem;"
              plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="8" [(ngModel)]="pageAreaWidth" [tabindex]="0">
          </div>

          <div class="list-input-title">ページ領域高さ(mm)</div>
          <div class="list-input-content">
            <input class="text-label-required align-right" type="text" id="txti_PageAreaHeight" style="width:8rem;"
              plessInputTextSub [restrict]="'[0-9.]'" [maxlength]="8" [(ngModel)]="pageAreaHeight" [tabindex]="0">
          </div>

          <div class="list-input-title">グリッド</div>
          <div class="list-input-content">
            <label>横</label>
            <wj-input-number class="numeric-stepper" [step]="1" id="ns_PageDivW" [(ngModel)]="pageDivW" [min]="1"
              [max]="99" [isRequired]="false" [tabindex]="0" [format]="'n0'">
            </wj-input-number>
            <label>×</label>
            <label>縦</label>
            <wj-input-number class="numeric-stepper" [step]="1" id="ns_PageDivW" [(ngModel)]="pageDivH" [min]="1"
              [max]="99" [isRequired]="false" [tabindex]="0" [format]="'n0'">
            </wj-input-number>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" (click)="eventCreateHandler()" [tabindex]="0">作成</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventCloseHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>